import SnackbarCmp from "../controls/feedback/Snackbar";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {actions} from "./NotificationRedux";

export function Notification() {

    const notificationState = useSelector((state) => state.notification);
    const dispatch = useDispatch();
    return (
        <>
            <SnackbarCmp
                open={notificationState.open}
                message={notificationState.message}
                variant={notificationState.variant}
                onClose={() => {
                    dispatch(actions.openNotification(false))
                }}
            />
        </>
    )
}